import React from "react";
import "./scss/style.scss";
import Router from "./router/Router";

function App() {
  return <Router />;
}

export default App;
